<template>
    <div>
        <a-form>
            <a-form-item v-bind="validateInfos.username">
                <a-input v-model:value="loginForm.username" placeholder="帐号" @change="handlerUser('1')" size="large">
                    <template #prefix>
                        <UserOutlined type="user" style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                </a-input>
            </a-form-item>
            <a-form-item v-bind="validateInfos.password">
                <a-input-password v-model:value="loginForm.password" placeholder="密码" @change="handlerUser('2')"
                    type="password" size="large">
                    <template #prefix>
                        <LockOutlined class="site-form-item-icon" style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                </a-input-password>
            </a-form-item>
            <div class="remenber">
                <!-- <a-checkbox>自动登录</a-checkbox> -->
                <a @click="$emit('handlerForgetPass')" style="float: right">忘记密码</a>
            </div>
            <a-form-item>
                <a-button :loading="loading" style="width: 100%; height: 40px" @click.prevent="loginUser(loginForm)"
                    type="primary">{{ button_login }}</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import { login, getLic } from "@/views/login/api";
import { listenKeyDownFunc } from "@/utils";
import { $post, $get } from "@/utils/request";
import { GloTips, phoneTips } from "@/views/components/api/api";
import { message } from "ant-design-vue";
import Termsindex from "@/views/login/terms.vue";
import { UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined } from "@ant-design/icons-vue";
import { reactive, toRaw } from 'vue';
import { Form } from 'ant-design-vue';
const useForm = Form.useForm;
export default {
    components: { Termsindex, UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined },
    props: {
        terms: '',
        is_user: '',
        username: ''
    },
    data() {
        const loginForm = reactive({
            username: this.username == '' ? '' : this.username,
            password: '',
        });
        const rules = reactive({
            username: [{ required: true, validator: GloTips }],
            password: [{ required: true, validator: GloTips }],
        });
        const { validate, validateInfos } = useForm(loginForm, rules);
        return {
            loginForm,
            validate,
            validateInfos,
            rules,
            loading: false,
            button_login: "登录",
        };
    },
    methods: {
        loginUser(s) {
            this.validate().then(() => {
                this.handlerLogin(s)
            }).catch(err => {
                this.loading = false;
            });
        },
        handlerLogin(s) {
            if (this.terms) {
                this.loading = true;
                this.button_login = "登录中";
                // getLic().then((res) => {
                // if (res.code) {
                login(s, (token) => {
                    this.$store.dispatch("user/login", token).then(() => {
                        const _redirect = this.$route.query.redirect;
                        const sub_id = this.$route.query.sub_id;
                        const status = this.$route.query.status;
                        const title = this.$route.query.title;
                        const proj_type = this.$route.query.proj_type;
                        const oper_type = this.$route.query.oper_type;
                        const page = this.$route.query.page;
                        const perpage = this.$route.query.perpage;
                        if (_redirect) {
                            if (_redirect == "no-permission" || _redirect == "/no-permission") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect == "404" || _redirect == "/404") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect == "modify" || _redirect == "/modify") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect == "refresh" || _redirect == "/refresh") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect.indexOf('mbr403') > -1) {
                                this.$router.push({ path: "/home/workspace" });
                            } else {
                                if (_redirect.indexOf('?id=') > -1) {
                                    let i = _redirect.indexOf('?id=')
                                    let id = _redirect.slice(i + 4)
                                    this.$router.push({
                                        path: _redirect,
                                        query: { id, status, title, proj_type, oper_type, page, perpage },
                                    });
                                } else if (_redirect.indexOf('?sub_id=') > -1) {
                                    let i = _redirect.indexOf('?sub_id=')
                                    let sub_id = _redirect.slice(i + 8)
                                    this.$router.push({
                                        path: _redirect,
                                        query: { sub_id, status, title, proj_type, oper_type, page, perpage },
                                    });
                                } else {
                                    this.$router.push({
                                        path: _redirect,
                                        query: { status, title, proj_type, oper_type, page, perpage },
                                    });
                                }
                            }
                            this.loading = false;
                        } else {
                            this.$router.push({ path: "/home/workspace" });
                            this.loading = false;
                            this.button_login = "登录";
                        }
                    }).catch((err) => {
                        this.loading = false;
                        this.button_login = "登录";
                    });
                });
                // } else {
                //     message.error(res.msg)
                //     this.loading = false;
                //     this.button_login = "登录";
                // }
                // }).catch((err) => {
                //     message.error(err)
                //     this.loading = false;
                //     this.button_login = "登录";
                // })

            } else {
                this.$emit("handlerClause")
            }
        },
        handlerUser(value) {
            if (value == "1") {
                this.loginForm.username = this.loginForm.username.replaceAll(" ", "");
            } else if (value == "2") {
                this.loginForm.password = this.loginForm.password.replaceAll(" ", "");
            } else if (value == "3") {
                this.codeForm.verkey = this.codeForm.verkey.replaceAll(" ", "");
            }
        },
    },
    mounted() {
        localStorage.setItem("query", JSON.stringify({}));
        listenKeyDownFunc({
            keyCode: 13,
            callback: () => {
                if (this.is_user && localStorage.getItem('user') == null) {
                    this.loginUser(this.loginForm);
                }
            },
        });
    },
}
</script>

<style></style>